export const INFO : IProductCardListWithText = {
    headline: 'Headline in two lines lorem ipsum dolor sit amet',
    subHeadline: 'Donec ullamcorper nulla non metus auctor fringilla. Maecenas sed diam eget risus varius blandit sit amet non magna. Nulla vitae elit libero, a pharetra augue.',
    productCardList: [],
    buttonText: 'Explore More',
    buttonLink: '/',
    buttonExternalLink: false
}
